import { PRODUCT_FORM_TYPES } from '../../lib/consts';
import { FormField } from '../../lib/interfaces/Form';
import { FIELD_TYPES } from '../Form/form.utils';
import { FILE_TYPES } from '../Form/form.validations';

const INTERVIEW_TYPES = [
	{
		label: 'technicalInterview',
		value: 'technical',
	},
	{
		label: 'hrInterview',
		value: 'HR',
	},
	{
		label: 'screeningInterview',
		value: 'screening',
	},
	{
		label: 'matchingInterview',
		value: 'matching',
	},
];

const ORDER_FORM_FIELDS: {
	[key: string]: string;
} = {
	CURRENT_POSITION: 'currentPosition',
	DESIRED_POSITION: 'desiredPosition',
	INTERVIEW_TYPE: 'interviewType',
	CV: 'cv',
	MESSAGE: 'message',
	LINK: 'link',
};

export const availableOrderFormFields: FormField[] = [
	{
		name: ORDER_FORM_FIELDS.CURRENT_POSITION,
		init: '',
		label: 'currentPosition',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 100,
		},
	},
	{
		name: ORDER_FORM_FIELDS.DESIRED_POSITION,
		init: '',
		label: 'desiredPosition',
		required: true,
		type: FIELD_TYPES.TEXT,
		validation: {
			maxLength: 100,
		},
	},
	{
		name: ORDER_FORM_FIELDS.INTERVIEW_TYPE,
		init: [],
		label: 'interviewType',
		required: true,
		type: FIELD_TYPES.SELECT,
		options: INTERVIEW_TYPES,
	},
	{
		name: ORDER_FORM_FIELDS.CV,
		init: '',
		label: 'CV',
		required: true,
		type: FIELD_TYPES.FILE,
		validation: {
			maxFileByteSize: 1054101,
			allowedExtensions: [
				FILE_TYPES.JPEG,
				FILE_TYPES.JPG,
				FILE_TYPES.PNG,
				FILE_TYPES.PDF,
				FILE_TYPES.DOC,
				FILE_TYPES.DOCX,
			],
		},
	},
	{
		name: ORDER_FORM_FIELDS.LINK,
		init: '',
		label: 'linkToGithub',
		required: true,
		type: FIELD_TYPES.TEXT,
	},
	{
		name: ORDER_FORM_FIELDS.MESSAGE,
		init: '',
		label: 'yourMessage',
		required: false,
		type: FIELD_TYPES.TEXTAREA,
	},
];

const getFormFields = (fields: {
	[key: string]: Partial<FormField>;
}): FormField[] =>
	Object.entries(fields).map(([key, replacemnet]) => {
		const availableField = availableOrderFormFields.find(
			(fieldItem) => fieldItem.name === key,
		);
		return availableField
			? {
					...availableField,
					...replacemnet,
			  }
			: availableOrderFormFields[0];
	});

export const getFieldsByFormType = {
	[PRODUCT_FORM_TYPES.INTERVIEW]: () =>
		getFormFields({
			[ORDER_FORM_FIELDS.INTERVIEW_TYPE]: {},
			[ORDER_FORM_FIELDS.CV]: {},
			[ORDER_FORM_FIELDS.DESIRED_POSITION]: {},
			[ORDER_FORM_FIELDS.CURRENT_POSITION]: {},
			[ORDER_FORM_FIELDS.MESSAGE]: {},
		}),
	[PRODUCT_FORM_TYPES.CONSULTATION]: () =>
		getFormFields({
			[ORDER_FORM_FIELDS.CURRENT_POSITION]: {},
			[ORDER_FORM_FIELDS.DESIRED_POSITION]: { required: false },
			[ORDER_FORM_FIELDS.CV]: { required: false },
			[ORDER_FORM_FIELDS.MESSAGE]: {
				required: true,
				label: 'writeYourQuestions',
			},
		}),
	[PRODUCT_FORM_TYPES.EXERCISE_REVIEW]: () =>
		getFormFields({
			[ORDER_FORM_FIELDS.LINK]: {},
			[ORDER_FORM_FIELDS.MESSAGE]: {},
		}),
};

export const PRODUCT_CONTENT_FIELDS = {
	FULL: 'content_full',
	ORDER_PAGE: 'content_order_page',
	REGULAR: 'content',
	NAME: 'name',
};
